export const isRecordCreationTicketType = (type) => ['l0_create', 'l1_create'].includes(type);
export const getRecordCreationLevel = (type) => type === 'l1_create' ? 'l1' : 'l0';
export const getRecordCreationRequestKey = (type) => `${getRecordCreationLevel(type)}_request`;

export const recordCreationFieldGroups = [
  { key: 'identity', label: 'Provider identity', hint: 'Provider, source, currency & country', open: true },
  { key: 'commercial', label: 'Commercial terms', hint: 'Costing & settlement', open: true },
  { key: 'reporting', label: 'Reporting', hint: 'Timezones, indicators & remarks' },
  { key: 'integration', label: 'Integration settings', hint: 'Credential keys, callbacks & links' }
];

export const getRecordCreationFieldGroup = (key) => {
  if (key.startsWith('reporting_')) return 'reporting';
  if (['costing_rates', 'costing_rate_rules', 'settlement_period', 'is_carry_forward', 'topup_options'].includes(key)) return 'commercial';
  if (['api_credential_keys', 'bo_credential_keys', 'callback_urls', 'group_links'].includes(key)) return 'integration';
  return 'identity';
};
